/**
 * A new temporary ISRC (`temporaryIsrcPattern` in
 * `@libs/catalog-engine-contracts/song`): `LIS-TEMP-` and 16 random bytes in
 * upper-case hex, for a song the admin adds before its real ISRC exists. It
 * draws from Web Crypto, so it lives here and not in the contracts package,
 * which holds the pattern and the pure checks.
 */
export const createTemporaryIsrc = (): string => {
  const bytes = new Uint8Array(16);
  globalThis.crypto.getRandomValues(bytes);
  const suffix = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0"))
    .join("")
    .toUpperCase();
  return `LIS-TEMP-${suffix}`;
};
